var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Prop, Watch } from "vue-property-decorator";
import { DataGrid, DataGridItem } from "@zct1989/vue-component";
import { PhoneNumberService } from "~/services/repair-service/phone-number.service";
import SimpleQueryInfo from "~/components/common/simple-query-info.vue";
var WorkPhoneQuery = /** @class */ (function (_super) {
    __extends(WorkPhoneQuery, _super);
    function WorkPhoneQuery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            phoneNumber: ""
        };
        _this.backModel = {};
        _this.rules = {
            phoneNumber: [{ required: true, message: "请输入手机号码", trigger: "blur" }, { validator: _this.$validator.phoneNumber, trigger: 'blur' }],
        };
        return _this;
    }
    WorkPhoneQuery.prototype.onPhoneNumberChange = function (val) {
        if (val) {
            this.model.phoneNumber = this.phoneNumber;
            this.search();
        }
    };
    WorkPhoneQuery.prototype.search = function () {
        var _this = this;
        var form = this.$refs["form"];
        form.validate(function (valid) {
            if (!valid)
                return;
            _this.phoneNumberService.searchPhoneNumber(_this.model)
                .subscribe(function (data) {
                _this.backModel = data;
            });
        });
    };
    WorkPhoneQuery.prototype.mounted = function () {
        this.onPhoneNumberChange(this.phoneNumber);
    };
    __decorate([
        Dependencies(PhoneNumberService)
    ], WorkPhoneQuery.prototype, "phoneNumberService", void 0);
    __decorate([
        Prop()
    ], WorkPhoneQuery.prototype, "phoneNumber", void 0);
    __decorate([
        Watch('phoneNumber')
    ], WorkPhoneQuery.prototype, "onPhoneNumberChange", null);
    WorkPhoneQuery = __decorate([
        Component({
            components: {
                DataGrid: DataGrid,
                DataGridItem: DataGridItem,
                SimpleQueryInfo: SimpleQueryInfo
            }
        })
    ], WorkPhoneQuery);
    return WorkPhoneQuery;
}(Vue));
export default WorkPhoneQuery;
